export enum TrainingExerciseGroupId {
  BALLISTICS = 'BAL',
  CARDIO = 'CRD',
  ENDURANCE = 'END',
  FOOTBALL = 'FTB',
  BASKETBALL = 'BSKT',
  PLYOMETRICS = 'PLY',
  SPEED = 'SPD',
  STRENGTH = 'STGH',
  MOBILITY = 'MOB',
  SWIMMING = 'SWM'
}

export const TrainingExercisesGroups = {
  [TrainingExerciseGroupId.BALLISTICS]: {
    key: TrainingExerciseGroupId.BALLISTICS,
    params: {
      NMRP: null,
      RSSTDR: null,
      RSRPDR: null,
      NUMGC: null,
      NOTHR: null,
      WGHT: null
    }
  },
  [TrainingExerciseGroupId.CARDIO]: {
    key: TrainingExerciseGroupId.CARDIO,
    params: {
      NMRP: null,
      RSSTDR: null,
      PRSCR: null,
      DIST1: null,
      DR1: null,
      SPD1: null,
      INCL1: null,
      INTS1: null,
      NOFL1: null,
      FIVPC1: null,
      RPM1: null,
      WAT1: null,
      DIST2: null,
      DR2: null,
      SPD2: null,
      INCL2: null,
      INTS2: null,
      NOFL2: null,
      FIVPC2: null,
      RPM2: null,
      WAT2: null
    }
  },
  [TrainingExerciseGroupId.ENDURANCE]: {
    key: TrainingExerciseGroupId.ENDURANCE,
    params: {
      NMRP: null,
      RSSTDR: null,
      PRSCR: null,
      DR1: null,
      DR2: null,
      DIST1: null,
      DIST2: null,
      SPD1: null,
      SPD2: null
    }
  },
  [TrainingExerciseGroupId.FOOTBALL]: {
    key: TrainingExerciseGroupId.FOOTBALL,
    params: {
      EXDR: null,
      STDR: null,
      RSSTDR: null,
      NMRP: null,
      RSPRDR: null,
      WRPRDR: null,
      DMS: null,
      NMST: null,
      PLST: null,
      MTPRPL: null,
      DMS1: null,
      DMS2: null,
      EFFRT: null,
      TRRN: null,
      GOAL: null,
      JKR: null,
      JKRNR: null,
      NMCNT: null
    }
  },
  [TrainingExerciseGroupId.BASKETBALL]: {
    key: TrainingExerciseGroupId.BASKETBALL,
    params: {
      RSSTDR: null,
      NMRP: null,
      RSPRDR: null,
      WRPRDR: null,
      CRTAREA: null,
      INTST: null,
      FRMT: null,
      CNTCT: null
    }
  },
  [TrainingExerciseGroupId.PLYOMETRICS]: {
    key: TrainingExerciseGroupId.PLYOMETRICS,
    params: {
      NMRP: null,
      RSSTDR: null,
      RSRPDR: null,
      NUMGC: null,
      JMHGT: null
    }
  },
  [TrainingExerciseGroupId.SPEED]: {
    key: TrainingExerciseGroupId.SPEED,
    params: {
      NMRP: null,
      RSSTDR: null,
      RPRSDR: null,
      RPWRDR: null,
      SPD: null,
      DIST: null,
      NUMCOD: null,
      DEGCOD: null,
      TRRN: null
    }
  },
  [TrainingExerciseGroupId.STRENGTH]: {
    key: TrainingExerciseGroupId.STRENGTH,
    params: {
      FVCH: null,
      FVZN: null,
      CNTP: [],
      ISDR: null,
      EXDR: null,
      CNDR: null,
      SSCDR: null,
      TPPSC: null,
      STDR: null,
      RIR: null,
      NMRP: null,
      MTPSC: null,
      WGHT: null,
      PERRM: null,
      RSSTDR: null
    }
  },
  [TrainingExerciseGroupId.MOBILITY]: {
    key: TrainingExerciseGroupId.MOBILITY,
    params: {
      NMRP: null,
      RSSTDR: null,
      RPRSDR: null,
      RPWRDR: null,
      CNTDR: null,
      RLDR: null
    }
  },
  [TrainingExerciseGroupId.SWIMMING]: {
    key: TrainingExerciseGroupId.SWIMMING,
    params: {
      NMRP: null,
      INTDST: null,
      INTDR: null,
      RSTTP: null,
      TTHLNG: null,
      RSSTDR: null
    }
  }
}
